import { supabase } from '../../lib/supabaseClient';

export async function getSetting<T = unknown>(key: string): Promise<T | null> {
  const { data, error } = await supabase.from('site_settings').select('value').eq('key', key).maybeSingle();
  if (error) throw error;
  return (data?.value as T) ?? null;
}

export async function setSetting(key: string, value: unknown) {
  const { error } = await supabase
    .from('site_settings')
    .upsert({ key, value, updated_at: new Date().toISOString() }, { onConflict: 'key' });
  if (error) throw error;
}

export type SiteSettings = {
  booking_email?: string;
  merch_shopify_url?: string;
  contact_form_enabled?: boolean;
};

export const SETTINGS_KEYS = {
  site: 'site',
} as const;
